import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { RfpClientOneSideMenuFile } from '@/components/modules/pages/rfp/client/Surface/RfpClientOneSideMenuFile';
import { propArrayShape, propBool, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { useUnmountRef } from '../../../../../../helpers/use/useHook';
import { rfpAdviserUseCase } from '../../UseCase/RfpAdviserUseCase';
import { rfpMemberUseCase } from '../../UseCase/RfpMemberUseCase';
import ConsultantAdviser from '../Adviser/ConsultantAdviser';
import RfpClientMemberList from './MemberList/RfpClientMemberList';
const RfpContentSubMenu = (props) => {
    const { className, isCanUpdateMember, isMemberAdmin, members, rfp } = props;
    const { additional_files: additionalFiles, admin, file, id } = rfp;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const addModal = rfpMemberUseCase.useAddMemberModal(id, dispatch, unmountRef);
    const updateModal = rfpMemberUseCase.useUpdateAdminModal(id, dispatch, unmountRef);
    const deleteModal = rfpMemberUseCase.useDeleteMemberModal(id, members, dispatch, unmountRef);
    return (_jsxs("div", Object.assign({ className: clsx(className, 'pb-4') }, { children: [admin && (_jsx(ConsultantAdviser, { admin: admin, id: id, useCase: rfpAdviserUseCase })), _jsx(RfpClientMemberList, { addModal: addModal, deleteModal: deleteModal, isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, updateModal: updateModal }), file && (_jsx(RfpClientOneSideMenuFile, { additionalFiles: additionalFiles, file: file }))] })));
};
RfpContentSubMenu.propTypes = {
    className: propStr(),
    isCanUpdateMember: propBool().isRequired,
    isMemberAdmin: propBool().isRequired,
    members: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
RfpContentSubMenu.defaultProps = {
    className: 'rfp_content_sub',
};
export default RfpContentSubMenu;
